function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Laptop"
}, /*#__PURE__*/React.createElement("title", null, "VF_laptop_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M0 212.6h283.5v28.3H0zM255.1 56.7H28.3v141.5h226.8V56.7zm-28.3 113.1H56.7V85h170.1v84.8z"
}))));